import React, { Component } from 'react';
import ListCreator from "../elements/listCreator"
import Viewer from '../elements/viewer';
import { formatDate } from "../utils/tools";
import * as design from "../../resources/constants/design";

const styleList = {
  container: 'BRL Wide100 TopMargin10px  NoBorder ',
  line: 'BRL Wide100 Padding0px NoBorder  btn-light ',
  column: 'BRL Padding10px NoBorder Hand MinWide30',
  label: 'BRL Wide100 LabelFont FS42 Padding0px NoBorder',
  text: 'BRL Wide100 TitleFont FS40 Padding0px NoBorder ',
};
const columns = ['item', 'offer'];
export default class Event extends Component {
  
  constructor(props) {
    super(props);
    this.setEditor = (editor) => { this.editor = editor; };
  }
  
  // ############################ RENDER ###################################
  // ############################ RENDER ###################################
  render() {
    
    const { style, data } = this.props 
    const dateMeta = this.formatEventDateMeta(data);

    return (
      <React.Fragment>
      <div className="BRL Wide100" style={{maxHeight:'600px', overflow:'hidden', display: 'flex', flexDirection: 'column'}} >
       
        <div className="BRL Wide100 TopMargin0px HPadding10px" style={{flex:1}}> 
          <div className={style.title}>{data.title}</div>
          <div className={style.time_container + " popup-event-date-row"}>
            <div className="popup-event-date-pill">
              <div className="popup-event-date-weekday">{dateMeta.weekday}</div>
              <div className="popup-event-date-monthday">{dateMeta.monthDay}</div>
            </div>
            <div className="popup-event-date-copy">
              <div className="popup-event-date-label">{dateMeta.relative}</div>
              <div className="popup-event-date-full">{dateMeta.fullDate}</div>
            </div>
          </div>
        </div>
          
        <div className="BRL Wide100 TopMargin0px HPadding10px" style={{flex:4, overflow: 'auto',maxHeight:'400px'}}> 
          {data.images && <div className="BRL Wide100 VPadding10px HPadding20px VIEW">
            <Viewer type="display" styleList={design.VIEWER_AD} id={data.id_business} images={data.images} />
          </div>}
          {data.description.length > 2 && <div className={style.description + " popup-description-panel"}>{data.description}</div>}
        </div>

        <div className="BRL Wide100 TopMargin0px HPadding10px" style={{flex:1, overflow: 'hidden'}}>
          <ListCreator type={"display"} styleList={styleList} data={data.promotion} columns={columns}></ListCreator>
        </div>
        
      </div>
      </React.Fragment>
      
    );

  }


  // ############################ FORMAT EVENT DATE FOR POPUP ############################
  // ############################ FORMAT EVENT DATE FOR POPUP ############################
  formatEventDateMeta(data){
    const eventDate = new Date(data && data['date']);
    if (!eventDate || Number.isNaN(eventDate.getTime())) {
      return {
        weekday: 'Date',
        monthDay: '',
        relative: 'Schedule unavailable',
        fullDate: ''
      };
    }

    const weekday = formatDate(eventDate, 'day ddL').split(' ')[0];
    const monthDay = formatDate(eventDate, 'M ddL');
    const fullDate = formatDate(eventDate, 'M dd YYL');

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const eventDay = new Date(eventDate);
    eventDay.setHours(0, 0, 0, 0);

    const oneDay = 24 * 60 * 60 * 1000;
    const dayDiff = Math.round((eventDay.getTime() - today.getTime()) / oneDay);

    let relative = 'Upcoming event';
    if (dayDiff === 0) {
      relative = 'Today';
    } else if (dayDiff === 1) {
      relative = 'Tomorrow';
    } else if (dayDiff > 1 && dayDiff <= 7) {
      relative = 'In ' + dayDiff + ' days';
    } else if (dayDiff > 7) {
      relative = 'Later this month';
    } else if (dayDiff === -1) {
      relative = 'Yesterday';
    } else if (dayDiff < -1) {
      relative = 'Past event';
    }

    return {
      weekday: weekday,
      monthDay: monthDay,
      relative: relative,
      fullDate: fullDate
    };
  }
  
}
